import fs from "fs";
import { Image, Box, Flex, Heading, Text, SimpleGrid, Button } from "@chakra-ui/react";
import Head from "next/head";
import { getImageAndTitleFromContent } from "../../utils/image-title";
import MarkdownContent from "../../components/markdown-content";
import { getPosts } from "../../server/get-posts";
import { getLanguagePages } from "../../server/get-language-pages";
import FeatureCheckList from "../../components/feature-check-list";
import LandingContent from "../../components/landing-content";
import { useRouter } from "next/router";
import { LandingLocale } from "../../localization/landing";
import { localeFromLangCode } from "../../utils/locale-from-header";

export default function Post({
  content,
  image,
  title,
  l,
}: {
  content: string;
  image: string;
  title: string;
  l: LandingLocale;
}) {
  const router = useRouter();

  const onSignupClick = (e?: React.MouseEvent<HTMLButtonElement>) => {
    e?.preventDefault();

    router.push({
      pathname: "/authentication/signup",
      query: { forwardSignup: true },
    });
  };

  return (
    <>
      <Head>
        <title>{`${title} | Talkio AI`}</title>
        <meta property="og:title" content={title} key="title" />
        <meta property="og:image" content={image} key="image" />
      </Head>
      <LandingContent>
        <SimpleGrid backgroundColor="gray.700" columns={{ base: 1, md: 2 }} spacing={0}>
          <Box display={{ base: "none", md: "block" }}>
            <Image src={image} alt={title} h="100%" objectFit="cover" />
          </Box>

          <Box p={5}>
            <Heading size="sm" mb={2} as="h2" color="#fff">
              {title}
            </Heading>
            <Text fontSize="sm" color="#fff">
              Practice speaking with an AI tutor who is always available and receive immediate
              feedback on your language skills. Just 10 minutes a day can significantly improve your
              pronunciation and fluency.
            </Text>
            <FeatureCheckList color="#fff" my={4} l={l} />

            <Button
              mt={5}
              colorScheme={"brand.green"}
              maxW={{ base: "100%", sm: "300px" }}
              onClick={onSignupClick}
            >
              Try Talkio - 7 days free
            </Button>
          </Box>
        </SimpleGrid>

        <MarkdownContent>{content}</MarkdownContent>

        <Flex justifyContent={"center"}>
          <Button
            my={10}
            size="xl"
            colorScheme={"brand.primary"}
            color="black"
            maxW={{ base: "100%", sm: "300px" }}
            onClick={onSignupClick}
          >
            Try Talkio - 7 days free
          </Button>
        </Flex>
      </LandingContent>
    </>
  );
}

export async function getStaticProps({ params }: { params: { id: string } }) {
  const content = fs.readFileSync(`./pages/languages/md/${params.id}.md`, "utf8");

  const { title } = getImageAndTitleFromContent(content);
  const translations = localeFromLangCode(); // todo: pass lang code here to get the correct locale

  return {
    props: {
      l: translations.l,
      content,
      image: `/languages/${params.id}.webp`,
      title,
    },
  };
}

export async function getStaticPaths() {
  const pages = getLanguagePages();

  return {
    paths: pages,
    fallback: false,
  };
}
